import { Menu, Upload, UploadFile } from 'antd';
import {
    IActivityReportPayslips,
    IActivityReportResponse,
    ISalarySimulations,
} from '../../../common/api/services/ActivityApi/types/IActivityReportResponse';
import { consultantApi } from '../../../common/api/services/ConsultantApi/consultantApi';
import { openErrorNotification } from '../../../components/notification/Notification';
import { commonDTOPeriod } from '../../../common/constants/dateConstants';
import moment from 'moment';

interface IProps {
    onOpenGenerateInvoice: (item: any) => void;
    onUpload: (file: UploadFile<any>[], publicId: number, period: string) => void;
    consultant: IActivityReportResponse;
    period: string;
    deletePayslip: (consultantId: string, id: string, type: 'payslip' | 'simulation') => void;
    publicId: number;
    payslips: Array<IActivityReportPayslips>;
    salarySimulations: Array<ISalarySimulations>;
    setDeletedFiles: (files: Array<string>) => void;
    setIsOpenDeleteFiles: (isOpen: boolean) => void;
    timesheetId: string;
}

const ActionMenu = (props: IProps) => {
    const {
        onOpenGenerateInvoice,
        onUpload,
        consultant,
        deletePayslip,
        publicId,
        period,
        payslips,
        salarySimulations,
        setDeletedFiles,
        setIsOpenDeleteFiles,
        timesheetId,
    } = props;

    const onDownload = () => {
        if (process.env.REACT_APP_GENERATE_PAYSLIP !== 'true') {
            return;
        }
        consultantApi
            .downloadCSVEmployee([
                {
                    publicId: consultant?.publicId,
                    companyId: consultant?._id?.projectId,
                    period: moment(consultant?._id?.period).format(commonDTOPeriod),
                },
            ])
            .then(() => {
                consultantApi.downloadCSVActivityReport([consultant?.publicId]);

                consultantApi.downloadCSVChildren([consultant?.publicId]);
            })
            .catch(async (e) => {
                try {
                    const blob = e?.response?.data;

                    if (!(blob instanceof Blob)) {
                        openErrorNotification('Unexpected error format');
                        return;
                    }
                    const text = await blob.text();

                    try {
                        const json = JSON.parse(text);
                        if (json?.messages?.length) {
                            openErrorNotification(json.messages[0].message);
                        } else if (json?.message) {
                            openErrorNotification(json.message);
                        } else {
                            openErrorNotification('Unknown error format received');
                        }
                    } catch {
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;

                        const disposition = e?.response?.headers?.['content-disposition'];
                        const filename =
                            disposition?.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)?.[1]?.replace(/['"]/g, '') ||
                            'report.xlsx';

                        a.download = filename;
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                        window.URL.revokeObjectURL(url);
                    }
                } catch (error) {
                    console.error('Fatal error parsing response:', error);
                    openErrorNotification('Unexpected error occurred while processing file or response');
                }
            });
    };

    const allItems = [
        {
            key: '1',
            label: (
                <Upload
                    onChange={(value) => onUpload(value.fileList, publicId, period)}
                    beforeUpload={() => false}
                    fileList={[]}
                    multiple={false}
                >
                    <span>Upload payslip</span>
                </Upload>
            ),
        },
        {
            key: '2',
            label: <span onClick={onOpenGenerateInvoice}>Generate invoice</span>,
        },
        {
            key: '7',
            label: <span onClick={onDownload}>Generate payslip</span>,
        },
    ];

    const isHasPayslips = payslips.length > 0 && payslips[0].originalFilename;
    const ishasSimulation = salarySimulations.length > 0 && salarySimulations[0].originalFilename;

    if (isHasPayslips && !ishasSimulation) {
        allItems.push({
            key: '4',
            label: (
                <span
                    style={{ color: '#C33025' }}
                    onClick={() => deletePayslip(payslips[0].consultantId, payslips[0]._id, 'payslip')}
                >
                    Delete payslip
                </span>
            ),
        });
    }

    if (ishasSimulation && !isHasPayslips) {
        allItems.push({
            key: '5',
            label: (
                <span
                    style={{ color: '#C33025' }}
                    onClick={() =>
                        deletePayslip(salarySimulations[0].consultantId, salarySimulations[0]._id, 'simulation')
                    }
                >
                    Delete simulation
                </span>
            ),
        });
    }

    if (isHasPayslips && ishasSimulation) {
        allItems.push({
            key: '6',
            label: (
                <span
                    style={{ color: '#C33025' }}
                    onClick={() => {
                        setIsOpenDeleteFiles(true);
                        setDeletedFiles([timesheetId]);
                    }}
                >
                    Delete files
                </span>
            ),
        });
    }

    return <Menu items={allItems} />;
};

export default ActionMenu;
